import React from "react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";

// Initialize Sentry
Sentry.init({
  dsn: "https://47a2cb28c1e19452ea6d3e8857a4c65a@o4510187505844224.ingest.de.sentry.io/4510187524980816",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Set environment
  environment: process.env.NODE_ENV,
  // Enable performance monitoring
  tracesSampleRate: 1.0,
  // Enable session tracking
  autoSessionTracking: true,
  // Configure release
  release: process.env.REACT_APP_VERSION || "1.0.0",
});

const LightTheme = React.lazy(() => import("./themes/lightTheme"));
const DarkTheme = React.lazy(() => import("./themes/darkTheme"));

const options = {
  api_host: "https://us.i.posthog.com",
  defaults: "2025-05-24",
};

const TYPE_OF_THEME = {
  LIGHT_MODE: "L",
  DARK_MODE: "D",
};
// const ThemeSelector = ({ children }) => {
//   const CHOSEN_THEME = localStorage.getItem('TYPE_OF_THEME') || TYPE_OF_THEME.DARK_MODE;
//   console.log(CHOSEN_THEME)
//   return (
//     <>
//       <React.Suspense fallback={<></>}>
//         {(CHOSEN_THEME === TYPE_OF_THEME.LIGHT_MODE) && <LightTheme />}
//         {(CHOSEN_THEME === TYPE_OF_THEME.DARK_MODE) && <DarkTheme />}
//       </React.Suspense>
//       {children}
//     </>
//   )
// }

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Sentry.ErrorBoundary
    fallback={({ error, resetError }) => (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <h2>Something went wrong!</h2>
        <p>We've been notified about this error.</p>
        <button onClick={resetError}>Try again</button>
      </div>
    )}
  >
    {/* <ThemeSelector> */}
    <PostHogProvider
      apiKey="phc_8VdzoyIkzLKsijcS68Y1EhtAIZBWDadj1kQHyt8iAdL"
      options={options}
    >
      <App />
    </PostHogProvider>
    {/* </ThemeSelector> 00*/}
  </Sentry.ErrorBoundary>
);

reportWebVitals();
